import React, { useState, useRef, useLayoutEffect } from 'react';
import { SubTitle, styled, Flex, Checkbox, Tooltip } from '@teko/ds-desktop';
import { DownOutlined } from '@teko/ds-icon';
import { t } from '../../i18n.es.js';

const FilterCheckbox = ({
  isActive,
  onClickOption,
  option,
  collapseContentWidth,
  collapseContentColumn,
  setCollapseContentColumn
}) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    if (ref.current && collapseContentWidth) {
      const checkboxSize = ref.current.offsetWidth + 28;
      if (checkboxSize > collapseContentWidth / 2 && collapseContentColumn === 2) {
        setCollapseContentColumn(1);
      }
    }
  }, [setCollapseContentColumn, collapseContentWidth, collapseContentColumn]);
  return /* @__PURE__ */ React.createElement(Checkbox, {
    checked: isActive,
    onChange: (_checked) => {
      onClickOption == null ? void 0 : onClickOption(option);
    },
    paddingRight: "s8"
  }, /* @__PURE__ */ React.createElement(Tooltip, {
    title: option.optionName,
    triggerHover: true
  }, /* @__PURE__ */ React.createElement("div", {
    ref
  }, option.optionName)));
};
const FilterCollapse = ({
  filter,
  active = false,
  activeOptions = [],
  onClickOption
}) => {
  const [show, setShow] = useState(active);
  const [max, setMax] = useState(4);
  const checkboxsRef = useRef(null);
  const [collapseContentWidth, setCollapseContentWidth] = useState(0);
  const [collapseContentColumn, setCollapseContentColumn] = useState(2);
  const { options } = filter;
  useLayoutEffect(() => {
    if (checkboxsRef.current) {
      setCollapseContentWidth(checkboxsRef.current.offsetWidth);
    }
  }, [checkboxsRef]);
  if (!filter.options.length)
    return null;
  return /* @__PURE__ */ React.createElement(Collapse, null, /* @__PURE__ */ React.createElement(CollapseHeader, {
    onClick: () => setShow(!show)
  }, /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4,
    weight: "medium"
  }, filter.name), /* @__PURE__ */ React.createElement(StyledDownOutlined, {
    className: show ? "active" : "",
    color: "textPrimary"
  })), /* @__PURE__ */ React.createElement(CollapseContent, {
    className: show ? "active" : "",
    ref: checkboxsRef
  }, /* @__PURE__ */ React.createElement(StyledFlex, {
    direction: "row"
  }, options.slice(0, max).map((option, index) => {
    const isActive = activeOptions.filter((curr) => curr.optionCode === option.optionCode).length > 0;
    return /* @__PURE__ */ React.createElement("div", {
      key: index,
      style: {
        minWidth: collapseContentColumn === 2 ? "50%" : "100%"
      }
    }, /* @__PURE__ */ React.createElement(FilterCheckbox, {
      isActive,
      onClickOption,
      option,
      collapseContentWidth,
      collapseContentColumn,
      setCollapseContentColumn
    }));
  })), max < options.length && /* @__PURE__ */ React.createElement(ViewAll, {
    onClick: () => setMax(options.length)
  }, t("Xem th\xEAm"))));
};
const ViewAll = styled.span(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.link500};
  cursor: pointer;
  font-size: 0.75rem;
  margin-left: 1.7rem;
`);
const StyledDownOutlined = styled(DownOutlined)`
  transition: 0.2s;
  &.active {
    transform: rotate(180deg);
  }
`;
const Collapse = styled.div``;
const CollapseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  height: 1.5rem;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;
const CollapseContent = styled.div(({ theme }) => `
  height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 0.25rem;
  &.active {
    margin-top: ${theme == null ? void 0 : theme.spacing.s12};
    height: auto;
  }
`);
const StyledFlex = styled(Flex)`
  flex-wrap: wrap;
`;

export { FilterCollapse };
